var __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

define(['jquery', 'core', 'model/base'], function($, core, BaseModel) {
  var AddOnModel;
  return AddOnModel = (function(_super) {

    __extends(AddOnModel, _super);

    function AddOnModel() {
      AddOnModel.__super__.constructor.apply(this, arguments);
    }

    AddOnModel.prototype.pathRoot = core.getConfig().apiPrefix + 'addon.json';

    AddOnModel.prototype.defaults = function() {
      return {
        id: null,
        clientId: null,
        name: null,
        details: null,
        collectionMethod: null,
        optimizationStatus: null,
        volume: null,
        dateActive: null,
        dateInactive: null,
        order: null,
        accountType: null,
        closeDayOfMonth: null
      };
    };

    return AddOnModel;

  })(BaseModel);
});
